// 自定义组件
import Vue from "vue"
const requireComponents = require.context('./', true, /\.vue/)
requireComponents.keys().forEach(fileName => {

  const reqCom = requireComponents(fileName)
  const reqComName =reqCom.name|| fileName.replace(/\.\/(.*)\.vue/,'$1')
  // 组件挂载
  Vue.component(reqComName, reqCom.default || reqCom)
})



